import { ChangeDetectionStrategy, Component, Input, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BankAccount } from '../../models/bank-account';
import { BehaviorSubject, Observable } from 'rxjs';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionCollapse, NgbAccordionDirective, NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { ReviewEntryComponent } from '../../../shared/components/review-components/review-entry/review-entry.component';
import { RadioButtonInputComponent } from '../../../../ui/form-components/radio-button-input/radio-button-input.component';

@Component({
  selector: 'app-bank-account-accordion-card',
  templateUrl: './bank-account-accordion-card.component.html',
  styleUrls: ['./bank-account-accordion-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionCollapse,
    ReviewEntryComponent,
    RadioButtonInputComponent
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountAccordionCardComponent {
  @Input() bankAccount!: BankAccount;
  @Input() index!: number;

  private _accordionIsExpanded = new BehaviorSubject<boolean>(false);
  public accordionIsExpanded$ = this._accordionIsExpanded as Observable<boolean>;

  public toggleAccordionExpand(): void {
    this.accordionIsExpanded$.once(expanded => {
      this._accordionIsExpanded.next(!expanded);
    });
  }
}
